import { Select, Option } from 'element-ui'
import HttpFactory from '@/mixins/http.factory';
export default {
	name:'configure',
	mixins:[HttpFactory],
	data () {
		return {
			data:null,
			configData:{fieldMapping:[],hdFields:[],githubFields:[],githubMapList:[],zendeskMapList:[]},
            fieldsMapping:[]
		}
	},
	created(){
		this.init();
	},
	methods:{
		init(){
			let _self=this;
			modalClient = ZAFClient.init();
			parentClient=null;
			modalClient.on('send_data_to_modal', async (data) => {
				if (data.ticket.id == _self.$route.params.zdTicketId) {
					parentClient = modalClient.instance(data.parentClientGuid)
					_self.zendeskInfo = data;
					await _self.getConfigData();
				}
			});
		},
		async getConfigData(){
			let _self=this;
			_self.fn().clearMessage();
			_self.fn().showLoader(true);
			let url =`configData/get`;
			let data={auth:_self.zendeskInfo.credentials};
			let response=await _self.post(url,data);
			_self.fn().showLoader(false);
			let configData=response.data.Data;
			configData.zendeskMapList=configData.hdFields.filter(d=>d.removable);//.filter(d=>d.type && d.type.indexOf('custom')>=0);
			configData.zendeskMapList=configData.zendeskMapList.filter(d=>d.type=='text' || d.type=='textarea' || d.type=='integer');

			//only text or strig type
			configData.githubMapList=configData.githubFields.value.filter(d=>d.referenceName && d.referenceName.indexOf('Custom')>=0);
			configData.githubMapList=configData.githubMapList.filter(d=>d.type=='integer' || d.type=='string' || d.type=='html');
			
			
			_self.configData=configData;
			let fieldsMapping=response.data.Data.fieldsMapping;
			if(!fieldsMapping){
				fieldsMapping={
					hdFieldName:'',
					hdFieldMappingId:'',
					githubFieldName:'',
					githubFieldMappingId:'',
				}

				let defaultZdField=configData.hdFields.find(d=>d.title=="Zendesk Ticket #");
				fieldsMapping.hdFieldName=defaultZdField?defaultZdField.id:'';

				let defaultDevField=configData.githubFields.value.find(d=>d.name=="Issue #");
				fieldsMapping.githubFieldName=defaultDevField?defaultDevField.referenceName:'';
			}else{
				fieldsMapping.githubFieldMappingId=fieldsMapping.githubFieldMappingId?parseInt(fieldsMapping.githubFieldMappingId):fieldsMapping.githubFieldMappingId;
			}
			_self.fieldsMapping=fieldsMapping;
			
		},
		handleFieldType:function(fieldMappingId,type){
			let _self=this;
			if(type=='github'){
				let field=_self.configData.githubFields.value.find(d=>d.referenceName==fieldMappingId);
				if(field){
					_self.fieldsMapping.githubFieldType=field.type;
				}
			}
			if(type=='zendesk'){
				let field=_self.configData.hdFields.find(d=>d.id==fieldMappingId);
				if(field){
					_self.fieldsMapping.hdFieldType=field.type;
				}
			}
		},
		saveConfigDataFn(){
			let _self=this;
			_self.fn().clearMessage();
			let url=`fieldsmapping/saveupdate`;
			_self.handleFieldType(_self.fieldsMapping.hdFieldMappingId,'github')
			_self.handleFieldType(_self.fieldsMapping.devOpsFieldMappingId,'zendesk');

			let data=_self.fieldsMapping;
			data.auth=_self.zendeskInfo.credentials;
			data.user=_self.zendeskInfo.user;
			_self.fn().showLoader(true);
			_self.post(url,data).then(response=>{
				_self.fn().showLoader(false);
				let data=response.data.Data;
				if(response.data.Success){
					let userMsg={show:true,type:'info',list:[response.data.Data?response.data.Data:`Config data saved Successfully`]}
					_self.userMsg=userMsg;
				}
				//_self.sendDataToParent(response.data);
			}).catch(error=>{
				_self.fn().showLoader(false);
				_self.commonErrorMsgDisp(error);
			});
		},
		getFieldsmapping(){
			let _self=this;
			let url=`fieldsmapping/get`;
			let data={auth:_self.zendeskInfo.credentials};
			_self.post(url,data).then(response=>{
				_self.fn().showLoader(false);
				let fieldsMapping=response.data.Data;
				_self.fieldsMapping=fieldsMapping;
			}).catch(error=>{
				_self.commonErrorMsgDisp(error);
			});
		},
		closeDialog(){
			modalClient.invoke('destroy');
		},
		sendDataToParent(data){
			parentClient.trigger('receive_data_from_modal', data)
      		modalClient.invoke('destroy');

		}
	},
	components:{[Select.name]: Select,[Option.name]: Option}
}

